import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';
import AntImport from './AntImport';
import AntConfig from '../utils/AntConfig';
import AntMessageBox from './AntMessageBox';

import { AntGlobal, AntSession } from '../utils/AntContext';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();
    const location = useLocation();
    const navigate = useNavigate();

    if (props.API && !props.API.entityDisplay) {
        if (appGlobal && appGlobal.appConfig && appGlobal.appConfig.Services) {
            let found = appGlobal.appConfig.Services.find((s) => s.name === props.API.entityName);
            if (found) props.API.init({ entityDisplay: found.display });
        }
    }

    const mainTable = props.table ? props.table : props.API ? props.API.entityName : '';
    const mainEntityName = props.API && props.API.entityName ? props.API.entityName : '';
    const mainEntityDisplay = props.API && props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay ? props.entityDisplay : '';

    const mainConfig = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === mainTable);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, mainTable);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: mainTable,
            config: cnf
        });
        return cnf;
    }, []);

    const show = async (obj) => {
        if (!popup.current) return;

        Object.keys(obj).forEach((k) => {
            if (obj[k] === undefined) delete obj[k];
        });

        var preparedObj = { ...props.defaultObj, ...obj };
        if (props.onPrepared) await props.onPrepared(preparedObj);
        setMainData(preparedObj);

        popup.current.show(preparedObj);

        return;
    };

    const [mainData, setMainData] = useState({});

    const popup = useRef();

    const onPostingCustomData = (rows) => {
        if (props.import && props.import.postPreFiltering) {
            rows = rows.filter((row) => {
                return props.import.postPreFiltering(row);
            });
        }

        var newRows = [];

        if (rows instanceof Array) {
            rows = rows.slice();

            rows.forEach((row) => {
                var itemObj = { row_index: row.row_index, is_import: true };

                if (props.import && props.import.postFields instanceof Array)
                    props.import.postFields.forEach((field) => {
                        if (typeof field === 'object') {
                            var rowField = field.field;
                            var postField = field.alias;

                            itemObj[postField] = row[rowField];
                        } else {
                            itemObj[field] = row[field];
                        }
                    });

                if (props.import && props.import.copyFromHeaderFields instanceof Array)
                    props.import.copyFromHeaderFields.forEach((field) => {
                        if (typeof field === 'object') {
                            var parentField = field.field;
                            var aliasField = field.alias ? field.alias : field.field;

                            if (mainData && mainData[parentField] !== undefined) {
                                if (field.when && typeof field.when === 'object') {
                                    var isValid = AntCondition.isValid(mainData, {
                                        when: field.when,
                                        whenType: field.whenType
                                    });
                                    if (!isValid) return;
                                }

                                itemObj[aliasField] = mainData[parentField];
                            }
                        } else if (mainData && mainData[field] !== undefined) itemObj[field] = mainData[field];
                    });

                Object.keys(itemObj).forEach((k) => {
                    if ((typeof itemObj[k] === 'object' && itemObj[k] !== null) || typeof itemObj[k] === 'function') itemObj[k] = undefined;
                });

                newRows.push({ ...itemObj });
            });
        }

        if (props.import && props.import.postRequiredFields instanceof Array) {
            newRows = newRows.filter((row) => {
                var keys = Object.keys(row).filter((k) => row[k] !== undefined);
                return props.import.postRequiredFields.filter((k) => !keys.includes(k)).length <= 0;
            });
        }

        if (props.import && props.import.postFiltering) {
            newRows = newRows.filter((row) => {
                return props.import.postFiltering(row);
            });
        }

        if (props.import && props.import.postModifier) {
            newRows = newRows.map((row) => {
                return props.import.postModifier(row, {
                    import: popup.current
                });
            });
        }

        return newRows;
    };

    const onValidateCustomData = (rows) => {
        var newRows = [];

        if (rows instanceof Array) {
            rows = rows.slice();

            rows.forEach((row) => {
                var itemObj = { row_index: row.row_index, is_import: true };

                if (props.import && props.import.postFields instanceof Array)
                    props.import.postFields.forEach((field) => {
                        if (typeof field === 'object') {
                            var rowField = field.field;
                            var postField = field.alias;

                            itemObj[postField] = row[rowField];
                        } else {
                            itemObj[field] = row[field];
                        }
                    });

                if (props.import && props.import.copyFromHeaderFields instanceof Array)
                    props.import.copyFromHeaderFields.forEach((field) => {
                        if (typeof field === 'object') {
                            var parentField = field.field;
                            var aliasField = field.alias ? field.alias : field.field;

                            if (mainData && mainData[parentField] !== undefined) {
                                if (field.when && typeof field.when === 'object') {
                                    var isValid = AntCondition.isValid(mainData, {
                                        when: field.when,
                                        whenType: field.whenType
                                    });
                                    if (!isValid) return;
                                }

                                itemObj[aliasField] = mainData[parentField];
                            }
                        } else if (mainData && mainData[field] !== undefined) itemObj[field] = mainData[field];
                    });

                Object.keys(itemObj).forEach((k) => {
                    if ((typeof itemObj[k] === 'object' && itemObj[k] !== null) || typeof itemObj[k] === 'function') itemObj[k] = undefined;
                });

                newRows.push({ ...itemObj });
            });
        }

        return newRows;
    };

    useImperativeHandle(ref, () => ({
        show: show
    }));

    return (
        <React.Fragment>
            <div>
                <AntImport
                    ref={popup}
                    API={props.API}
                    table={props.import && props.import.table ? props.import.table : props.API ? props.API.entityName : props.table}
                    entityName={props.API && props.API.entityName ? props.API.entityName : ''}
                    entityDisplay={props.API && props.API.entityDisplay ? props.API.entityDisplay : ''}
                    previewWidth={props.import && props.import.previewWidth !== undefined ? props.import.previewWidth : undefined}
                    heights={props.import && props.import.heights !== undefined ? props.import.heights : undefined}
                    defaultPageSize={props.import && props.import.defaultPageSize !== undefined ? props.import.defaultPageSize : undefined}
                    createable={true}
                    updateable={false}
                    fields={props.import ? props.import.fields : undefined}
                    mapping={props.import ? props.import.mapping : []}
                    parentData={mainData}
                    onPostingCustomData={onPostingCustomData}
                    onValidateCustomData={onValidateCustomData}
                />
            </div>
        </React.Fragment>
    );
});
